import type { HttpPost } from '@/shared/infra/http'
import type { ReportMessage } from '@/modules/connect/use-cases'
import { mapConnectError } from './map-connect-error'

export class EdgeReportMessageRepository {
  constructor(private readonly http: HttpPost) {}

  execute: ReportMessage = async (params) => {
    try {
      const reason = params.reason?.trim()
      await this.http.post<unknown, unknown>({
        url: `/connect/messages/${encodeURIComponent(params.messageId)}/report`,
        body: {
          orgId: params.orgId,
          orgType: params.orgType,
          category: params.category,
          ...(reason ? { reason } : {}),
        },
      })
    } catch (err) {
      throw mapConnectError(err)
    }
  }
}
